"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShellPage = void 0;
const react_1 = __importStar(require("react"));
const environmentContextProvider_1 = __importDefault(require("@geome/react-next/lib/context/environmentContextProvider"));
const config_1 = require("@geome/react-next/lib/context/config");
const i18nContext_1 = require("@geome/react-next/lib/context/i18nContext");
const cssCustomProperty_1 = require("@geome/react-next/lib/context/cssCustomProperty");
const embedding_1 = require("@geome/react-next/lib/context/embedding");
const i18n_1 = __importDefault(require("@geome/intl/lib/i18n"));
const matchesMediaSwitcher_1 = require("@geome/react-next/lib/util/matchesMediaSwitcher");
const react_use_1 = require("react-use");
require("@fontsource/roboto");
require("@fontsource/roboto/700.css");
const footer_1 = require("./components/footer");
const topNav_1 = require("./components/topNav");
const breadCrumbs_1 = require("@geome/react-components-next/lib/components/breadCrumbs");
const stickyButtons_1 = require("./components/stickyButtons");
const react_next_1 = require("@geome/react-next");
const shellStationPageContent_1 = require("./components/shellStationPageContent");
const i18nMode = process.env.DEPLOY_ENV === "prod" ? "production" : "test";
const ShellStationPage = ({ config, location, links, localeLinks, locatorLink, breadcrumbs, directionsLinkHref, nearby, }) => {
    var _a;
    const i18n = (0, react_1.useMemo)(() => {
        const i18n = new i18n_1.default();
        i18n.setIntlData(config.intlData);
        i18n.setMode(i18nMode);
        return i18n;
    }, [(_a = config.intlData) === null || _a === void 0 ? void 0 : _a.messages]);
    const intersectionRef = react_1.default.useRef(null);
    const intersection = (0, react_use_1.useIntersection)(intersectionRef, {
        root: null,
        rootMargin: "94px",
        threshold: 0.5,
    });
    const showStickyButtons = (0, react_1.useMemo)(() => {
        return (intersection && !intersection.isIntersecting) || false;
    }, [intersection]);
    const darkMode = (0, react_next_1.useMatchMedia)("(prefers-color-scheme: dark)");
    return (react_1.default.createElement(environmentContextProvider_1.default, { mobileMatchMedia: "(max-width: 560px)" },
        react_1.default.createElement(config_1.ConfigContext.Provider, { value: config },
            react_1.default.createElement(i18nContext_1.I18nContext.Provider, { value: i18n },
                react_1.default.createElement(cssCustomProperty_1.CSSCustomPropertyContextProvider, { properties: {
                        "--primary-colour": "#dd1d21",
                        "--secondary-colour": "#ffc400",
                        "--text-dark-colour": darkMode ? "#FFF" : "#4A4A4A",
                        "--max-page-width": "1440px",
                        "--max-grid-width": "1226px",
                        "--floating-title-height": "146px",
                        "--ev-charging-tab-background-colour": "#f6f6f6",
                        "--shell-red-colour": "#dd1d21",
                        "--shell-green-colour": "#6aa271",
                        "--properties-text-colour": "#4A4A4A",
                    } },
                    react_1.default.createElement(embedding_1.EmbeddingContext.Provider, { value: null },
                        react_1.default.createElement(topNav_1.StationPageTopNav, { locationName: location.name, links: links, localeLinks: localeLinks, breadcrumbs: breadcrumbs, mobileOnlyLinks: [
                                {
                                    translationToken: "station_page.sections.info.station_locator",
                                    link: locatorLink,
                                    newTab: false,
                                },
                            ] }),
                        react_1.default.createElement(stickyButtons_1.StickyButtons, { directionsLink: directionsLinkHref, locatorLink: locatorLink, shown: showStickyButtons, offersLength: location.offers.length }),
                        react_1.default.createElement(matchesMediaSwitcher_1.MatchesMediaSwitcher, { mediaQueries: ["(max-width: 560px)", "screen"] },
                            react_1.default.createElement(react_1.default.Fragment, null),
                            react_1.default.createElement(breadCrumbs_1.Breadcrumbs, { breadcrumbs: breadcrumbs, seperatorStyle: "chevrons", renderAfter: () => react_1.default.createElement(StationLocatorButton, { locatorLink: locatorLink }) })),
                        react_1.default.createElement(shellStationPageContent_1.ShellStationPageContent, { location: location, ref: intersectionRef, nearby: nearby }),
                        react_1.default.createElement(matchesMediaSwitcher_1.MatchesMediaSwitcher, { mediaQueries: ["(max-width: 560px)", "screen"] },
                            react_1.default.createElement(react_1.default.Fragment, null),
                            react_1.default.createElement(breadCrumbs_1.Breadcrumbs, { breadcrumbs: breadcrumbs, seperatorStyle: "chevrons" })),
                        react_1.default.createElement("div", { className: "location-page__footer" },
                            react_1.default.createElement(footer_1.Footer, null))))))));
};
exports.default = ShellStationPage;
exports.ShellPage = shellStationPageContent_1.ShellStationPageContent;
const StationLocatorButton = ({ locatorLink }) => {
    const { translate } = (0, react_next_1.useI18n)();
    return (react_1.default.createElement("a", { className: "breadcrumbs__button", href: locatorLink }, translate("station_page.sections.info.station_locator")));
};
